// extracted by mini-css-extract-plugin
export default {"layout":"ReferralIds_layout__1ej9c","sidebar":"ReferralIds_sidebar__gLKyD","main":"ReferralIds_main__pNkkd"};